import React from 'react';
import { AICoworkers } from '../components/AICoworkers';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
import { AudienceSwitch } from '../components/AudienceSwitch';
import { NovaSection } from '../components/nova/NovaSection';
// New Giga home screen. The hero is the "Ask Giga anything, get it done."
// chat-box composer (HowItWorksConnections in hero mode), presented as a
// proper website hero. The Slack "@mention Giga" experience remains its own
// "Works where you work" section further down the page.
// The "AI Co-Pilot for Teams" homepage still lives at /future.
export function Home() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-3925" />
      <NovaSection data-id="element-3926" />
      <AudienceSwitch data-id="element-3927" />
      <AICoworkers isTasklet data-id="element-3928" />
      <HowItWorksConnections mode="how" data-id="element-3929" />
      <LivesInSlack data-id="element-3930" />
      <ComputerUse data-id="element-3931" />
      <CapabilityGrid data-id="element-3932" />
      <NarrativeSection data-id="element-3933" />
      <ToolComparison data-id="element-3934" />
      <WallOfLove data-id="element-3935" />
      <PricingSection data-id="element-3936" />
      <ClosingCTA data-id="element-3937" />
    </>;
}